import React from 'react';
import { Box, Typography } from '@mui/material';
import { useChatCardTokens } from './chatCards';

/**
 * A line across the chat that starts a new section, named by `label` with `icon` before it (the
 * MLS® form help names its field this way). Nothing without a label.
 */
const ChatSectionDivider = ({ label = null, icon = null }) => {
  const tokens = useChatCardTokens();
  if (!label) return null;
  const line = { flex: 1, minWidth: 16, borderTop: `1px solid ${tokens.line}` };

  return (
    <Box
      role="separator"
      aria-label={label}
      data-testid="chat-section-divider"
      sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 2, mx: 1, ...tokens.enter }}
    >
      <Box aria-hidden="true" sx={line} />
      <Box
        aria-hidden="true"
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0, maxWidth: '80%', color: tokens.slate[600] }}
      >
        {icon}
        <Typography variant="caption" noWrap sx={{ fontWeight: 600, color: tokens.slate[600] }}>
          {label}
        </Typography>
      </Box>
      <Box aria-hidden="true" sx={line} />
    </Box>
  );
};

export default ChatSectionDivider;
